export const COURSE_EDITOR_MUX_STATE = Object.freeze({
  MATCHING: "MATCHING",
  MISSING: "MISSING",
  PROCESSING: "PROCESSING",
  STALE: "STALE",
  ERROR: "ERROR",
  HELD_FOR_PRIMARY: "HELD_FOR_PRIMARY",
});

const text = (value) => String(value || "").trim();

export function getCourseEditorMuxState(video = {}) {
  const cloudflare = video?.providers?.cloudflare || {};
  const mux = video?.providers?.mux || {};
  const cloudflareCurrent = cloudflare.current;
  const cloudflareCandidate = cloudflare.candidate;
  const muxCurrent = mux.current;
  const muxCandidate = mux.candidate;
  const currentRevision = text(cloudflareCurrent?.contentRevision);
  const muxRevision = text(muxCurrent?.contentRevision);

  if (
    cloudflareCurrent?.status === "ready" &&
    muxCurrent?.status === "ready" &&
    currentRevision &&
    muxRevision === currentRevision
  ) {
    return COURSE_EDITOR_MUX_STATE.MATCHING;
  }
  if (muxCandidate?.status === "error") return COURSE_EDITOR_MUX_STATE.ERROR;
  if (["upload_pending", "uploading", "processing"].includes(text(muxCandidate?.status))) {
    return COURSE_EDITOR_MUX_STATE.PROCESSING;
  }
  if (muxCandidate?.status === "ready") {
    const candidateRevision = text(muxCandidate.contentRevision);
    const primaryCandidateRevision = text(cloudflareCandidate?.contentRevision);
    if (candidateRevision && primaryCandidateRevision === candidateRevision) {
      return COURSE_EDITOR_MUX_STATE.HELD_FOR_PRIMARY;
    }
    return COURSE_EDITOR_MUX_STATE.STALE;
  }
  if (muxCurrent?.assetId || muxCurrent?.status) return COURSE_EDITOR_MUX_STATE.STALE;
  return COURSE_EDITOR_MUX_STATE.MISSING;
}

export function shouldObserveCourseEditorVideo(video = {}) {
  const cloudflareCandidate = video?.providers?.cloudflare?.candidate;
  const cloudflareCandidatePending = !!cloudflareCandidate &&
    !["ready", "error"].includes(text(cloudflareCandidate.status));
  const cloudflareReady = !!video?.isReady || !!video?.readyToStream ||
    video?.status === "ready" || video?.providers?.cloudflare?.current?.status === "ready";
  const muxProcessing = getCourseEditorMuxState(video) === COURSE_EDITOR_MUX_STATE.PROCESSING;
  return !cloudflareReady || cloudflareCandidatePending || muxProcessing;
}

export function shouldPollCoursePreparation(job = null) {
  return ["queued", "running"].includes(text(job?.status));
}

export function isExactCourseVideoDeleteConfirmation(value) {
  return value === "DELETE";
}

export function shouldPollCourseVideoDeletion(operation = null) {
  return ["pending", "running"].includes(text(operation?.status));
}

export const CONTROLLED_MUX_BATCH_LIMIT = 10;

export function standbyPolicyUpdateErrorMessage() {
  return "ไม่สามารถเปลี่ยนการตั้งค่าระบบ Streaming สำรองได้ กรุณาลองอีกครั้ง";
}

export function toggleControlledMuxLessonSelection(selected = [], lesson = {}, {
  limit = CONTROLLED_MUX_BATCH_LIMIT,
} = {}) {
  const key = [lesson.headerId, lesson.sectionId, lesson.itemId].map(text).join("/");
  if (!key || key === "//") return selected;
  const existing = selected.findIndex((entry) => entry.key === key);
  if (existing >= 0) return selected.filter((_, index) => index !== existing);
  if (selected.length >= limit) return selected;
  return [...selected, { key, headerId: text(lesson.headerId), sectionId: text(lesson.sectionId),
    itemId: text(lesson.itemId), title: text(lesson.title) }];
}

export function shouldShowCourseStructurePlaceholder({ loading, hasStructure }) {
  return loading === true && hasStructure !== true;
}

export function startCoursePreparationPolling({
  active,
  refresh,
  intervalMs = 5000,
  setIntervalFn = window.setInterval.bind(window),
  clearIntervalFn = window.clearInterval.bind(window),
}) {
  if (!active || typeof refresh !== "function") return () => {};
  let inFlight = false;
  const intervalId = setIntervalFn(async () => {
    if (inFlight) return;
    inFlight = true;
    try {
      await refresh();
    } finally {
      inFlight = false;
    }
  }, intervalMs);
  return () => clearIntervalFn(intervalId);
}
